<template>
    <div class="task-price-box">
        <div class="task-price-header">
            <h3>汇总</h3>
        </div>
        <div class="task-api-num">
            <div class="api-title">
                <span>API交易次数</span>
            </div>
            <div class="api-box">
                <div class="api-box-item" v-for="(item, index) in apiTradeData" :key="index">
                    <div>
                        <label for="">{{index}}: </label>
                    </div>
                    <span>{{item}} (次)</span>
                </div>
            </div>
        </div>
        <div class="task-price-content">
            <div class="task-price-total">
                <span>交易额(当前/总计): </span>
                <span>{{positionData}}</span>
            </div>
            <div class="price-box" v-if="data">
                <!-- <div class="box-header">
                    <div class="box-header-item">XRP</div>
                    <div class="box-header-item">EOS</div>
                    <div class="box-header-item">BCH</div>
                    <div class="box-header-item">BSV</div>
                </div> -->
                <div class="box-body">
                    
                    <div class="box-body-item" v-for="(item, index) in data" :key="index" :style="{'color': currencyColor(item)}">
                        <div class="title">{{index}}</div>
                        <div class="text">{{item.toFixed(4)}}</div>
                    </div>

                    <!-- <div class="box-body-item" :style="{'color': currencyColor(data['XRP'])}">{{data['XRP'].toFixed(4)}}</div>
                    <div class="box-body-item" :style="{'color': currencyColor(data['EOS'])}">{{data['EOS'].toFixed(4)}}</div>
                    <div class="box-body-item" :style="{'color': currencyColor(data['BCH'])}">{{data['BCH'].toFixed(4)}}</div>
                    <div class="box-body-item" :style="{'color': currencyColor(data['BSV'])}">{{data['BSV'].toFixed(4)}}</div> -->
                </div>
            </div>
            <!-- <div class="price-box" v-if="data">
                <div class="box-header">
                    <div class="box-header-item">BTC</div>
                    <div class="box-header-item">ETH</div>
                    <div class="box-header-item">LTC</div>
                    <div class="box-header-item">TRX</div>
                </div>
                <div class="box-body">
                    <div class="box-body-item" :style="{'color': currencyColor(data['BTC'])}">{{data['BTC'].toFixed(4)}}</div>
                    <div class="box-body-item" :style="{'color': currencyColor(data['ETH'])}">{{data['ETH'].toFixed(4)}}</div>
                    <div class="box-body-item" :style="{'color': currencyColor(data['LTC'])}">{{data['LTC'].toFixed(4)}}</div>
                    <div class="box-body-item" :style="{'color': currencyColor(data['TRX'])}">{{data['TRX'].toFixed(4)}}</div>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { get } from '@/api/index'
import { mapState, mapAction } from 'vuex'

export default {
    data() {
        return {
            tradeNum: Object,
        }
    },
    props: {
        data: Object,
        positionData: String,
    },
    mounted() {
        this.getApiTradeNum();
    },
    computed: {
        ...mapState([
            'apiNameList'
        ]),

        // api交易次数计算
        apiTradeData() {
            if (this.apiNameList) {
                var new_data = {};
                for (var i=0; i<this.apiNameList.length; i++) {
                    var api_id = this.apiNameList[i].id;
                    var api_name = this.apiNameList[i].name;
                    if (this.tradeNum.hasOwnProperty(api_id)) {// 如果 this.tradeNum 有id，说明该api 有交易笔数
                        var api_trade_num = this.tradeNum[api_id];
                        new_data[api_name] = api_trade_num;
                    }
                }
                return new_data;
            }
        }
    },
    methods: {
        // 颜色判断
        currencyColor(data) {
            if (data) {
                if (String(data).includes('-')) {// 包含 - 符号
                    return '#1AB394';
                } else {
                    return '#db5634';
                }
            }
        },

        // 获取api的交易次数
        getApiTradeNum() {
            var url = this.$url_LN + '/web/get/order/apiNumber';
            get(url).then(resp => {
                if (resp.code == 200) {
                    this.tradeNum = resp.data;
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100,
                        duration: 1000
                    })
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
    .task-price-box{
        background-color: #2a2d2e;
        .task-price-header{
            h3{
                padding-left: 5px;
                text-align: left;
            }
        }
        .task-price-content{
            color: #97979a;
            padding: 0 3px;
            table{
                width: 100%;
            }
            .task-price-total{
                text-align: left;
                padding: 5px;
                background-color: #1e1e1e;
                margin-top: 5px;
                span{
                    margin-right: 5px;
                }
            }

            .price-box{
                width: 100%;
                background-color: #262829;
                .box-header{
                    padding: 5px;
                    display: flex;
                    flex-wrap: wrap;
                    .box-header-item{
                        font-weight: bold;
                        flex: 1;
                    }
                }
                .box-body{
                    padding: 5px;
                    display: flex;
                    flex-wrap: wrap;
                    .box-body-item{
                        flex: 1;
                        min-width: 50px;
                    }
                }
            }
        }

        .task-api-num{
            padding: 3px;
            font-size: 12px;
            .api-title{
                background-color: #1e1e1e;
                color: #97979a;
                text-align: left;
                padding: 3px;
            }
            .api-box{
                background-color: #262829;
                .api-box-item{
                    display: flex;
                    color: #97979a;
                    padding: 3px;
                    div{
                        flex: 1;
                        text-align: left;
                    }
                    span{
                        flex: 1;
                    }
                }
            }
        }
    }
</style>
